export default "__VITE_ASSET__DhXUHleD__"